/*
 * @Author: your name
 * @Date: 2021-08-14 17:09:05
 * @LastEditTime: 2021-09-06 17:10:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \enroll_vue\src\store\getters.js
 */

const getters = {
  showStyle: state => state.showStyle,
  columnId: state => state.columnId,
  labelIds: state => state.labelIds,
}
export default getters
